// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './style/index.css';

// 📌 Importar el AuthProvider
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    {/* ✅ Envolvemos toda la app con el AuthProvider */}
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);
